import { type ReactNode } from 'react'
import { ClerkProvider } from '@clerk/clerk-react'
import { tenantConfig } from '@/lib/tenant'
import { ClerkTokenSync } from './clerk'

export function AuthRootProvider({ children }: { children: ReactNode }) {
  if (tenantConfig.authProvider === 'clerk') {
    return (
      <ClerkProvider
        publishableKey={tenantConfig.clerkPublishableKey}
        signInUrl="/login"
        signUpUrl="/sign-up"
        signInFallbackRedirectUrl="/overview"
        signUpFallbackRedirectUrl="/overview"
        afterSignOutUrl="/login"
      >
        <ClerkTokenSync />
        {children}
      </ClerkProvider>
    )
  }

  return <>{children}</>
}
